(() => {
const root = document.getElementById("mousex-cat-widget");
const page = document.querySelector("[data-page]");
const canvas = root.querySelector("[data-game-canvas]");
const ctx = canvas.getContext("2d");
const startButton = root.querySelector("[data-start-game]");
const restartButton = root.querySelector("[data-restart-game]");
const pauseButton = root.querySelector("[data-pause-game]");
const audioButton = root.querySelector("[data-audio-toggle]");
const firePad = root.querySelector("[data-fire-pad]");
const overlay = root.querySelector("[data-overlay]");
const overlayTitle = root.querySelector("[data-overlay-title]");
const overlayScore = root.querySelector("[data-overlay-score]");
const statusLabel = root.querySelector("[data-status]");
const scoreLabel = root.querySelector("[data-score]");
const bestLabel = root.querySelector("[data-best]");
const livesLabel = root.querySelector("[data-lives]");
const waveLabel = root.querySelector("[data-wave]");
const W = canvas.width;
const H = canvas.height;
const SHIELD_SECONDS = 2;
const KEY = {
ArrowLeft: "left",
KeyA: "left",
ArrowRight: "right",
KeyD: "right",
ArrowUp: "up",
KeyW: "up",
ArrowDown: "down",
KeyS: "down",
Space: "fire"
};
const POWER_TYPES = [
{ id: "opticLaser", label: "OPT", name: "Optical Laser", color: "#2af6ff" },
{ id: "rapidTrigger", label: "RT", name: "Rapid Trigger", color: "#61ff8a" },
{ id: "antiGravity", label: "AG", name: "Anti-Gravity", color: "#a987ff" },
{ id: "shotgun", label: "SG", name: "Scatter Blaster", color: "#ff7d4a" },
{ id: "fluxBomb", label: "BOMB", name: "Flux Bomb", color: "#ffb038" },
{ id: "phaseShield", label: "SHD", name: "Phase Shield", color: "#f4f7ff" }
];
const storage = {
get() {
try {
return Number(localStorage.getItem("g6-he-cat-best") || localStorage.getItem("mousex-cat-best") || 0);
} catch (error) {
return 0;
}
},
set(value) {
try {
localStorage.setItem("g6-he-cat-best", String(value));
} catch (error) {
return false;
}
return true;
}
};
const audio = {
ctx: null,
master: null,
enabled: true,
unlocked: false,
beat: 0,
timer: 0,
pattern: [196, 0, 294, 247, 392, 0, 330, 247, 196, 294, 0, 392, 330, 247, 294, 0]
};
const state = {
raf: 0,
last: 0,
running: false,
paused: false,
gameOver: false,
score: 0,
best: storage.get(),
lives: 3,
wave: 1,
difficulty: 1,
spawnTimer: 0.4,
obstacleTimer: 2,
powerTimer: 6,
fireCooldown: 0,
elapsed: 0,
shake: 0,
flashText: "",
flashTimer: 0,
player: { x: W / 2, y: H - 86, r: 27, targetX: W / 2, targetY: H - 86 },
input: { left: false, right: false, up: false, down: false, fire: false },
pointerActive: false,
bullets: [],
cats: [],
obstacles: [],
powerUps: [],
particles: [],
rings: [],
effects: {
laser: 0,
rapid: 0,
gravity: 0,
shotgun: 0,
shield: 0,
shieldCharges: 0,
latency: 0
},
stars: Array.from({ length: 86 }, () => ({
x: Math.random() * W,
y: Math.random() * H,
z: 0.4 + Math.random() * 1.8,
blink: Math.random() * Math.PI * 2
}))
};
bestLabel.textContent = state.best;
function clamp(value, min, max) {
return Math.max(min, Math.min(max, value));
}
function rectsOverlap(a, b) {
return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
}
function distance(a, b) {
const dx = a.x - b.x;
const dy = a.y - b.y;
return Math.sqrt(dx * dx + dy * dy);
}
function syncHud() {
scoreLabel.textContent = state.score;
bestLabel.textContent = state.best;
livesLabel.textContent = state.lives;
waveLabel.textContent = state.wave;
}
function setOverlay(mode) {
overlay.hidden = mode === "hidden";
if (mode === "ready") {
overlayTitle.textContent = "Ready to Launch";
overlayScore.textContent = "Click Start Game to begin";
startButton.textContent = "Start Game";
}
if (mode === "pause") {
overlayTitle.textContent = "Paused";
overlayScore.textContent = `Current score ${state.score}`;
startButton.textContent = "Resume";
}
if (mode === "gameover") {
overlayTitle.textContent = "Mission Over";
overlayScore.textContent = `Run ${state.score} / Best ${state.best} - top 3 campaign scores can win a free G6 HE`;
startButton.textContent = "Play Again";
}
}
function unlockAudio() {
if (!audio.enabled || audio.unlocked) return;
const AudioContext = window.AudioContext || window.webkitAudioContext;
if (!AudioContext) return;
audio.ctx = audio.ctx || new AudioContext();
audio.master = audio.master || audio.ctx.createGain();
audio.master.gain.value = 0.11;
audio.master.connect(audio.ctx.destination);
audio.ctx.resume();
audio.unlocked = true;
}
function tone(freq, duration, type = "square", gain = 0.035, slide = 0) {
if (!audio.enabled || !audio.unlocked || !audio.ctx) return;
const now = audio.ctx.currentTime;
const osc = audio.ctx.createOscillator();
const vol = audio.ctx.createGain();
osc.type = type;
osc.frequency.setValueAtTime(freq, now);
if (slide) osc.frequency.exponentialRampToValueAtTime(Math.max(40, freq + slide), now + duration);
vol.gain.setValueAtTime(0.0001, now);
vol.gain.exponentialRampToValueAtTime(gain, now + 0.012);
vol.gain.exponentialRampToValueAtTime(0.0001, now + duration);
osc.connect(vol);
vol.connect(audio.master);
osc.start(now);
osc.stop(now + duration + 0.02);
}
function tickMusic(dt) {
if (!audio.enabled || !audio.unlocked || state.paused || state.gameOver) return;
audio.timer -= dt;
if (audio.timer > 0) return;
const note = audio.pattern[audio.beat % audio.pattern.length];
if (note) {
tone(note, 0.07, "triangle", 0.018);
if (audio.beat % 4 === 0) tone(note / 2, 0.1, "sawtooth", 0.015);
}
audio.beat += 1;
audio.timer = 0.18;
}
function pageShake() {
page.classList.remove("is-shaking");
void page.offsetWidth;
page.classList.add("is-shaking");
window.setTimeout(() => page.classList.remove("is-shaking"), 380);
}
function prepareGame() {
state.running = false;
state.paused = false;
state.gameOver = false;
state.score = 0;
state.lives = 3;
state.wave = 1;
state.difficulty = 1;
state.spawnTimer = 0.35;
state.obstacleTimer = 1.8;
state.powerTimer = 4.2;
state.fireCooldown = 0;
state.elapsed = 0;
state.shake = 0;
state.flashText = "";
state.flashTimer = 0;
state.player.x = W / 2;
state.player.y = H - 86;
state.player.targetX = W / 2;
state.player.targetY = H - 86;
state.bullets.length = 0;
state.cats.length = 0;
state.obstacles.length = 0;
state.powerUps.length = 0;
state.particles.length = 0;
state.rings.length = 0;
state.effects.laser = 0;
state.effects.rapid = 0;
state.effects.gravity = 0;
state.effects.shotgun = 0;
state.effects.shield = 0;
state.effects.shieldCharges = 0;
state.effects.latency = 0;
statusLabel.textContent = "Ready";
pauseButton.textContent = "Pause";
syncHud();
}
function resetGame() {
prepareGame();
state.running = true;
statusLabel.textContent = "G6 HE lane online";
setOverlay("hidden");
}
function startOrResume() {
unlockAudio();
if (state.gameOver || !state.running) {
resetGame();
return;
}
state.paused = false;
pauseButton.textContent = "Pause";
setOverlay("hidden");
}
function togglePause() {
unlockAudio();
if (!state.running || state.gameOver) return;
state.paused = !state.paused;
pauseButton.textContent = state.paused ? "Resume" : "Pause";
statusLabel.textContent = state.paused ? "Paused" : "G6 HE lane online";
setOverlay(state.paused ? "pause" : "hidden");
}
function finishGame() {
state.gameOver = true;
state.running = false;
state.input.fire = false;
state.pointerActive = false;
if (state.score > state.best) {
state.best = state.score;
storage.set(state.best);
}
statusLabel.textContent = "Mission Over";
syncHud();
root.dispatchEvent(new CustomEvent("g6he-score", {
bubbles: true,
detail: {
score: state.score,
best: state.best,
wave: state.wave,
game: "g6-he-cat-blaster",
product: "Keychron G6 HE UltraLight"
}
}));
tone(104, 0.28, "sawtooth", 0.03, -50);
setOverlay("gameover");
}
function fireRate() {
const rapid = state.effects.rapid > 0;
const delayed = state.effects.latency > 0;
if (state.effects.laser > 0) return delayed ? 0.2 : 0.13;
if (state.effects.shotgun > 0) return delayed ? 0.31 : 0.22;
return Math.max(0.075, 0.19 - state.wave * 0.006 - (rapid ? 0.045 : 0) + (delayed ? 0.08 : 0));
}
function shoot() {
const laser = state.effects.laser > 0;
const shotgun = state.effects.shotgun > 0;
const rapid = state.effects.rapid > 0;
state.fireCooldown = fireRate();
const spread = shotgun ? [-24, -12, 0, 12, 24] : rapid ? [-7, 7] : [0];
for (const offset of spread) {
state.bullets.push({
x: state.player.x + offset * 0.45,
y: state.player.y - 42,
w: laser ? 15 : shotgun ? 8 : rapid ? 8 : 7,
h: laser ? 82 : shotgun ? 22 : 24,
vx: offset * (shotgun ? 7.4 : 2.6) + (Math.random() - 0.5) * (laser ? 4 : 9),
vy: laser ? -820 : shotgun ? -610 : -590,
damage: laser ? 2 : shotgun ? 1 : rapid ? 1 : 1,
pierce: laser ? 4 : 1,
laser,
shotgun,
rapid
});
}
burst(state.player.x, state.player.y - 46, laser ? 8 : shotgun ? 7 : 4, "muzzle");
tone(laser ? 760 : shotgun ? 180 : 520, laser ? 0.06 : 0.045, laser ? "sine" : "square", 0.018, laser ? 180 : 0);
}
function spawnCat() {
const size = 34 + Math.random() * 18;
const x = 28 + Math.random() * (W - 56);
const speed = 72 + state.wave * 11 + state.elapsed * 1.2 + Math.random() * 54;
state.cats.push({
x,
y: -size - 20,
r: size * 0.55,
size,
vx: (Math.random() - 0.5) * (24 + state.wave * 4),
vy: speed,
spin: (Math.random() - 0.5) * 1.4,
rot: Math.random() * Math.PI * 2,
phase: Math.random() * Math.PI * 2
});
}
function spawnObstacle() {
const roll = Math.random();
const type = state.wave > 2 && roll < 0.18 ? "lag" : roll < 0.62 ? "keycap" : "switch";
const width = type === "keycap" ? 52 + Math.random() * 20 : type === "lag" ? 72 : 34 + Math.random() * 12;
const height = type === "keycap" ? 34 + Math.random() * 8 : type === "lag" ? 32 : 52 + Math.random() * 14;
const x = 34 + Math.random() * (W - 68);
const laneDrift = (Math.random() - 0.5) * (28 + state.wave * 5);
state.obstacles.push({
type,
x,
y: -height - 20,
w: width,
h: height,
hp: type === "keycap" ? 2 : type === "lag" ? 1 : 999,
vx: laneDrift,
vy: 84 + state.wave * 10 + state.elapsed * 0.9 + Math.random() * 34,
rot: (Math.random() - 0.5) * 0.24,
spin: (Math.random() - 0.5) * 0.18,
phase: Math.random() * Math.PI * 2
});
}
function obstacleBox(obstacle) {
return {
x: obstacle.x - obstacle.w / 2,
y: obstacle.y - obstacle.h / 2,
w: obstacle.w,
h: obstacle.h
};
}
function playerBox() {
return {
x: state.player.x - state.player.r * 0.55,
y: state.player.y - state.player.r * 0.78,
w: state.player.r * 1.1,
h: state.player.r * 1.45
};
}
function spawnPowerUp() {
const pool = state.wave < 3
? POWER_TYPES.filter((type) => type.id !== "fluxBomb" && type.id !== "antiGravity")
: POWER_TYPES;
const type = pool[Math.floor(Math.random() * pool.length)];
state.powerUps.push({
...type,
x: 36 + Math.random() * (W - 72),
y: -28,
r: type.id === "fluxBomb" ? 25 : 21,
vx: (Math.random() - 0.5) * 26,
vy: 66 + state.wave * 5 + Math.random() * 22,
rot: Math.random() * Math.PI * 2,
spin: (Math.random() - 0.5) * 1.2,
pulse: Math.random() * Math.PI * 2
});
}
function powerUpBox(powerUp) {
return {
x: powerUp.x - powerUp.r,
y: powerUp.y - powerUp.r,
w: powerUp.r * 2,
h: powerUp.r * 2
};
}
function activePowerLabel() {
const active = [];
if (state.effects.latency > 0) active.push("Latency Spike");
if (state.effects.shield > 0) active.push("SHD Invincible");
if (state.effects.laser > 0) active.push("Optical Laser");
if (state.effects.gravity > 0) active.push("Anti-Gravity");
if (state.effects.shotgun > 0) active.push("Scatter Blaster");
if (state.effects.rapid > 0) active.push("Rapid Trigger");
return active[0] || "";
}
function setStatusFlash(text, duration = 1.4) {
state.flashText = text;
state.flashTimer = duration;
statusLabel.textContent = text;
}
function shieldActive() {
return state.effects.shield > 0;
}
function dangerSize(target, kind) {
return kind === "cat" ? target.r : Math.max(target.w, target.h) * 0.55;
}
function inShieldField(target, kind) {
const reach = state.player.r + dangerSize(target, kind) + 58;
return distance(target, state.player) < reach;
}
function applyPowerUp(powerUp) {
burst(powerUp.x, powerUp.y, 18, "power");
tone(620, 0.08, "triangle", 0.03, 180);
if (powerUp.id === "opticLaser") {
state.effects.laser = Math.max(state.effects.laser, 6.2);
setStatusFlash("Optical Laser");
} else if (powerUp.id === "rapidTrigger") {
state.effects.rapid = Math.max(state.effects.rapid, 8);
setStatusFlash("Rapid Trigger");
} else if (powerUp.id === "antiGravity") {
state.effects.gravity = Math.max(state.effects.gravity, 6.5);
state.shake = Math.max(state.shake, 0.2);
setStatusFlash("Anti-Gravity Lift");
} else if (powerUp.id === "shotgun") {
state.effects.shotgun = Math.max(state.effects.shotgun, 7);
setStatusFlash("Scatter Blaster");
} else if (powerUp.id === "phaseShield") {
state.effects.shield = Math.max(state.effects.shield, SHIELD_SECONDS);
state.effects.shieldCharges = 1;
state.rings.push({ x: state.player.x, y: state.player.y, r: 34, life: 0.42, max: 0.42, color: "#f4f7ff" });
setStatusFlash("SHD Invincible", 1);
} else if (powerUp.id === "fluxBomb") {
triggerBomb(powerUp.x, powerUp.y);
}
}
function triggerBomb(x, y) {
let cleared = 0;
for (let i = state.cats.length - 1; i >= 0; i -= 1) {
const cat = state.cats[i];
state.cats.splice(i, 1);
state.score += 8;
cleared += 1;
burst(cat.x, cat.y, 18, "cat");
}
for (let i = state.obstacles.length - 1; i >= 0; i -= 1) {
const obstacle = state.obstacles[i];
if (obstacle.type === "keycap" || obstacle.type === "lag") {
state.obstacles.splice(i, 1);
state.score += obstacle.type === "lag" ? 5 : 3;
cleared += 1;
burst(obstacle.x, obstacle.y, 16, "obstacle");
} else {
obstacle.vy += 120;
obstacle.vx += obstacle.x < W / 2 ? -60 : 60;
}
}
state.best = Math.max(state.best, state.score);
state.shake = 1.2;
pageShake();
burst(x, y, 50, "bomb");
state.rings.push({ x, y, r: 8, life: 0.7, max: 0.7, color: "#ffb038" });
tone(140, 0.26, "sawtooth", 0.04, -80);
tone(72, 0.34, "square", 0.025, -20);
setStatusFlash(cleared ? "Flux Bomb Blast" : "Flux Bomb Ready", 1.6);
syncHud();
}
function repelDanger(target, kind) {
if (!shieldActive()) return false;
if ((target.shieldSafe || 0) > 0.08) return true;
const player = state.player;
const size = dangerSize(target, kind);
let dx = target.x - player.x;
let dy = target.y - player.y;
if (Math.abs(dx) + Math.abs(dy) < 1) {
dx = Math.random() < 0.5 ? -1 : 1;
dy = -1;
}
const len = Math.sqrt(dx * dx + dy * dy);
const nx = dx / len;
const ny = dy / len;
const gap = player.r + size + 64;
target.x = clamp(player.x + nx * gap, size + 8, W - size - 8);
target.y = clamp(player.y + ny * gap, -120, H + 80);
target.vx = nx * (kind === "cat" ? 420 : 340);
target.vy = ny * (kind === "cat" ? 430 : 360) + (ny < 0 ? -220 : 220);
target.rot += nx * 0.55;
target.shieldSafe = 0.9;
target.repelGlow = 0.42;
state.shake = Math.max(state.shake, 0.34);
burst(target.x, target.y, kind === "cat" ? 20 : 16, "shield");
state.rings.push({ x: player.x, y: player.y, r: 34, life: 0.34, max: 0.34, color: "#f4f7ff" });
tone(520, 0.08, "triangle", 0.024, 180);
setStatusFlash("Shield Repulse", 0.55);
return true;
}
function applyShieldField() {
if (!shieldActive()) return;
for (const obstacle of state.obstacles) {
if (inShieldField(obstacle, "obstacle")) repelDanger(obstacle, "obstacle");
}
for (const cat of state.cats) {
if (inShieldField(cat, "cat")) repelDanger(cat, "cat");
}
}
function shieldBlocksDamage(target, kind) {
if ((target.shieldSafe || 0) > 0) return true;
if (repelDanger(target, kind)) return true;
if (!shieldActive()) return false;
state.shake = Math.max(state.shake, 0.22);
setStatusFlash("Shield Holding", 0.45);
return true;
}
function loseLife(kind, target) {
if (target && shieldBlocksDamage(target, kind)) return true;
if (shieldActive()) {
setStatusFlash("Shield Holding", 0.45);
return true;
}
state.lives -= 1;
state.shake = kind === "cat" ? 0.7 : 0.8;
pageShake();
tone(kind === "cat" ? 118 : 110, kind === "cat" ? 0.18 : 0.2, "sawtooth", 0.035, kind === "cat" ? -45 : -40);
burst(state.player.x, state.player.y, kind === "cat" ? 30 : 28, kind);
syncHud();
if (state.lives <= 0) {
finishGame();
return false;
}
return true;
}
function burst(x, y, count, type) {
const palette = type === "cat"
? ["#ff39d5", "#2af6ff", "#d9ff4a", "#ffb038"]
: type === "obstacle"
? ["#2af6ff", "#ff39d5", "#aeb8df", "#ffffff"]
: type === "power"
? ["#d9ff4a", "#2af6ff", "#ff39d5", "#ffffff"]
: type === "bomb"
? ["#ffb038", "#d9ff4a", "#ff39d5", "#ffffff"]
: type === "shield"
? ["#f4f7ff", "#2af6ff", "#aeb8df"]
: ["#d9ff4a", "#2af6ff", "#ffffff"];
for (let i = 0; i < count; i += 1) {
const angle = Math.random() * Math.PI * 2;
const speed = 36 + Math.random() * 190;
const life = 0.35 + Math.random() * 0.42;
state.particles.push({
x,
y,
vx: Math.cos(angle) * speed,
vy: Math.sin(angle) * speed,
life,
max: life,
size: 2 + Math.random() * 5,
color: palette[Math.floor(Math.random() * palette.length)]
});
}
}
function getPointerPosition(event) {
const rect = canvas.getBoundingClientRect();
const x = (event.clientX - rect.left) / rect.width * W;
const y = (event.clientY - rect.top) / rect.height * H;
return { x, y };
}
function updatePlayer(dt) {
const player = state.player;
const rapidBoost = state.effects.rapid > 0 ? 64 : 0;
const latencyDrag = state.effects.latency > 0 ? 0.62 : 1;
const speed = (330 + state.wave * 4 + rapidBoost) * latencyDrag;
let dx = 0;
let dy = 0;
if (state.input.left) dx -= 1;
if (state.input.right) dx += 1;
if (state.input.up) dy -= 1;
if (state.input.down) dy += 1;
if (dx || dy) {
const len = Math.sqrt(dx * dx + dy * dy);
player.x += dx / len * speed * dt;
player.y += dy / len * speed * dt;
player.targetX = player.x;
player.targetY = player.y;
} else if (state.pointerActive) {
const follow = state.effects.latency > 0 ? 5.2 : 12;
player.x += (player.targetX - player.x) * Math.min(1, dt * follow);
player.y += (player.targetY - player.y) * Math.min(1, dt * follow);
}
player.x = clamp(player.x, 34, W - 34);
player.y = clamp(player.y, 84, H - 44);
}
function update(dt) {
if (!state.running || state.paused || state.gameOver) return;
state.elapsed += dt;
const timeWave = Math.floor(state.elapsed / 18);
state.wave = 1 + Math.floor(state.score / 120) + timeWave;
state.difficulty = 1 + state.wave * 0.08 + state.elapsed * 0.008;
state.shake = Math.max(0, state.shake - dt * 12);
state.fireCooldown = Math.max(0, state.fireCooldown - dt);
state.flashTimer = Math.max(0, state.flashTimer - dt);
state.effects.laser = Math.max(0, state.effects.laser - dt);
state.effects.rapid = Math.max(0, state.effects.rapid - dt);
state.effects.gravity = Math.max(0, state.effects.gravity - dt);
state.effects.shotgun = Math.max(0, state.effects.shotgun - dt);
state.effects.shield = Math.max(0, state.effects.shield - dt);
state.effects.latency = Math.max(0, state.effects.latency - dt);
if (state.effects.shield <= 0) state.effects.shieldCharges = 0;
tickMusic(dt);
updatePlayer(dt);
if ((state.input.fire || state.pointerActive) && state.fireCooldown <= 0) {
shoot();
}
for (const star of state.stars) {
star.y += (22 + star.z * 28 + state.wave * 2 + state.elapsed * 0.55) * dt;
star.blink += dt * 5;
if (star.y > H) {
star.y = -4;
star.x = Math.random() * W;
}
}
state.spawnTimer -= dt;
if (state.spawnTimer <= 0) {
spawnCat();
state.spawnTimer = Math.max(0.23, 1.02 - state.wave * 0.05 - state.elapsed * 0.003) + Math.random() * 0.22;
}
state.obstacleTimer -= dt;
if (state.elapsed > 6 && state.obstacleTimer <= 0) {
spawnObstacle();
state.obstacleTimer = Math.max(0.82, 3.2 - state.wave * 0.13 - state.elapsed * 0.008) + Math.random() * 0.55;
}
state.powerTimer -= dt;
if (state.elapsed > 5 && state.powerTimer <= 0) {
spawnPowerUp();
state.powerTimer = Math.max(4.1, 10.4 - state.wave * 0.34 - state.elapsed * 0.015) + Math.random() * 2.3;
}
for (const bullet of state.bullets) {
bullet.x += bullet.vx * dt;
bullet.y += bullet.vy * dt;
}
state.bullets = state.bullets.filter((bullet) => bullet.y + bullet.h > -20 && bullet.x > -50 && bullet.x < W + 50);
const fallScale = state.effects.gravity > 0 ? 0.46 : 1;
for (const cat of state.cats) {
cat.y += cat.vy * fallScale * dt;
cat.x += (cat.vx + Math.sin(state.elapsed * 2.1 + cat.phase) * (18 + state.wave)) * dt;
cat.rot += cat.spin * dt;
cat.shieldSafe = Math.max(0, (cat.shieldSafe || 0) - dt);
cat.repelGlow = Math.max(0, (cat.repelGlow || 0) - dt);
if (cat.x < 22 || cat.x > W - 22) cat.vx *= -1;
}
for (const obstacle of state.obstacles) {
obstacle.y += obstacle.vy * fallScale * dt;
obstacle.x += (obstacle.vx + Math.sin(state.elapsed * 1.6 + obstacle.phase) * 12) * dt;
obstacle.rot += obstacle.spin * dt;
obstacle.shieldSafe = Math.max(0, (obstacle.shieldSafe || 0) - dt);
obstacle.repelGlow = Math.max(0, (obstacle.repelGlow || 0) - dt);
if (obstacle.x < 28 || obstacle.x > W - 28) obstacle.vx *= -1;
}
applyShieldField();
for (const powerUp of state.powerUps) {
powerUp.y += powerUp.vy * dt;
powerUp.x += (powerUp.vx + Math.sin(state.elapsed * 2 + powerUp.pulse) * 10) * dt;
powerUp.rot += powerUp.spin * dt;
powerUp.pulse += dt * 4;
if (powerUp.x < 28 || powerUp.x > W - 28) powerUp.vx *= -1;
}
for (let i = state.powerUps.length - 1; i >= 0; i -= 1) {
const powerUp = state.powerUps[i];
if (rectsOverlap(playerBox(), powerUpBox(powerUp))) {
state.powerUps.splice(i, 1);
applyPowerUp(powerUp);
continue;
}
if (powerUp.y - powerUp.r > H + 30) {
state.powerUps.splice(i, 1);
}
}
for (let i = state.obstacles.length - 1; i >= 0; i -= 1) {
const obstacle = state.obstacles[i];
let removed = false;
const hitBox = obstacleBox(obstacle);
for (let j = state.bullets.length - 1; j >= 0; j -= 1) {
const bullet = state.bullets[j];
const bulletBox = { x: bullet.x - bullet.w / 2, y: bullet.y, w: bullet.w, h: bullet.h };
if (!rectsOverlap(bulletBox, hitBox)) continue;
const damage = bullet.damage || 1;
bullet.pierce = (bullet.pierce || 1) - 1;
if (bullet.pierce <= 0) state.bullets.splice(j, 1);
burst(bullet.x, bullet.y, obstacle.type === "switch" ? 8 : 12, "obstacle");
if (obstacle.type === "keycap" || obstacle.type === "lag") {
obstacle.hp -= damage;
obstacle.vy += 10 + damage * 4;
if (obstacle.hp <= 0) {
state.obstacles.splice(i, 1);
state.score += obstacle.type === "lag" ? 7 : 4;
state.best = Math.max(state.best, state.score);
state.shake = Math.max(state.shake, obstacle.type === "lag" ? 0.34 : 0.2);
burst(obstacle.x, obstacle.y, 18, "obstacle");
syncHud();
removed = true;
break;
}
} else {
state.shake = Math.max(state.shake, 0.12);
}
}
if (removed) continue;
if (rectsOverlap(playerBox(), hitBox)) {
if (shieldBlocksDamage(obstacle, "obstacle")) {
continue;
}
state.obstacles.splice(i, 1);
if (obstacle.type === "lag") {
state.effects.latency = Math.max(state.effects.latency, 3.2);
state.shake = Math.max(state.shake, 0.36);
setStatusFlash("Latency Spike", 1.2);
burst(obstacle.x, obstacle.y, 18, "obstacle");
tone(92, 0.16, "sawtooth", 0.025, 36);
continue;
}
if (!loseLife("obstacle", obstacle)) {
return;
}
continue;
}
if (obstacle.y - obstacle.h / 2 > H + 40 || obstacle.y + obstacle.h / 2 < -120) {
state.obstacles.splice(i, 1);
}
}
for (let i = state.cats.length - 1; i >= 0; i -= 1) {
const cat = state.cats[i];
let destroyed = false;
for (let j = state.bullets.length - 1; j >= 0; j -= 1) {
const bullet = state.bullets[j];
const hitBox = { x: cat.x - cat.r, y: cat.y - cat.r, w: cat.r * 2, h: cat.r * 2 };
if (rectsOverlap({ x: bullet.x - bullet.w / 2, y: bullet.y, w: bullet.w, h: bullet.h }, hitBox)) {
bullet.pierce = (bullet.pierce || 1) - 1;
if (bullet.pierce <= 0) state.bullets.splice(j, 1);
state.cats.splice(i, 1);
state.score += 10 + Math.min(12, state.wave);
state.best = Math.max(state.best, state.score);
state.shake = Math.max(state.shake, bullet.shotgun ? 0.2 : 0.34);
burst(cat.x, cat.y, 24, "cat");
destroyed = true;
syncHud();
break;
}
}
if (destroyed) continue;
if (distance(cat, state.player) < cat.r + state.player.r * 0.62) {
if (shieldBlocksDamage(cat, "cat")) {
continue;
}
state.cats.splice(i, 1);
if (!loseLife("cat", cat)) {
return;
}
continue;
}
if (cat.y - cat.r > H + 30 || cat.y + cat.r < -120) {
state.cats.splice(i, 1);
}
}
for (const particle of state.particles) {
particle.x += particle.vx * dt;
particle.y += particle.vy * dt;
particle.vy += 90 * dt;
particle.life -= dt;
}
state.particles = state.particles.filter((particle) => particle.life > 0);
for (const ring of state.rings) {
ring.r += 360 * dt;
ring.life -= dt;
}
state.rings = state.rings.filter((ring) => ring.life > 0);
const activeLabel = activePowerLabel();
statusLabel.textContent = state.flashTimer > 0
? state.flashText
: activeLabel
? activeLabel
: state.obstacles.length
? state.wave > 5 ? "Switch Storm" : "Lab Debris"
: state.wave > 5 ? "High-Energy Lane" : "G6 HE lane online";
}
function drawGrid() {
ctx.save();
ctx.globalAlpha = 0.22;
ctx.strokeStyle = state.effects.gravity > 0 ? "#a987ff" : "#2af6ff";
ctx.lineWidth = 1;
const horizon = H * 0.72;
for (let i = 0; i < 12; i += 1) {
const y = horizon + i * i * 2.8 + (state.elapsed * (state.effects.gravity > 0 ? -30 : 48)) % 20;
ctx.beginPath();
ctx.moveTo(0, y);
ctx.lineTo(W, y);
ctx.stroke();
}
for (let i = -6; i <= 6; i += 1) {
ctx.beginPath();
ctx.moveTo(W / 2, horizon);
ctx.lineTo(W / 2 + i * 70, H);
ctx.stroke();
}
ctx.restore();
}
function drawStars() {
for (const star of state.stars) {
const alpha = 0.38 + Math.sin(star.blink) * 0.28;
ctx.fillStyle = `rgba(244, 247, 255, ${alpha})`;
const size = star.z > 1.4 ? 3 : 2;
ctx.fillRect(Math.round(star.x), Math.round(star.y), size, size);
}
}
function drawBullet(bullet) {
ctx.save();
ctx.translate(Math.round(bullet.x), Math.round(bullet.y));
if (bullet.laser) {
ctx.fillStyle = "rgba(42, 246, 255, 0.32)";
ctx.fillRect(-9, -6, 18, 92);
ctx.fillStyle = "#2af6ff";
ctx.fillRect(-3, -4, 6, 88);
ctx.fillStyle = "#f4f7ff";
ctx.fillRect(-1, -8, 2, 96);
} else {
ctx.fillStyle = bullet.shotgun ? "#ff7d4a" : bullet.rapid ? "#61ff8a" : "#d9ff4a";
ctx.fillRect(-bullet.w / 2 + 1, 2, bullet.w - 2, bullet.h - 7);
ctx.fillStyle = "#ffffff";
ctx.fillRect(-2, 0, 4, 4);
ctx.fillStyle = bullet.shotgun ? "#ff39d5" : "#2af6ff";
ctx.fillRect(-5, bullet.h - 8, 10, 3);
ctx.fillStyle = bullet.shotgun ? "rgba(255, 125, 74, 0.35)" : "rgba(217, 255, 74, 0.35)";
ctx.fillRect(-2, bullet.h - 4, 4, 8);
}
ctx.restore();
}
function pixelRect(x, y, w, h, color) {
ctx.fillStyle = color;
ctx.fillRect(x, y, w, h);
}
function drawObstacle(obstacle) {
ctx.save();
ctx.translate(Math.round(obstacle.x), Math.round(obstacle.y));
ctx.rotate(obstacle.rot);
const w = obstacle.w;
const h = obstacle.h;
if (obstacle.repelGlow > 0) {
ctx.globalAlpha = 0.35 + obstacle.repelGlow;
ctx.strokeStyle = "#f4f7ff";
ctx.lineWidth = 4;
ctx.strokeRect(-w / 2 - 10, -h / 2 - 10, w + 20, h + 20);
ctx.globalAlpha = 1;
}
if (obstacle.type === "keycap") {
ctx.fillStyle = "rgba(255, 57, 213, 0.28)";
ctx.fillRect(-w / 2 - 4, -h / 2 + 4, w + 8, h);
ctx.fillStyle = "#dbe4ff";
ctx.fillRect(-w / 2, -h / 2, w, h);
ctx.fillStyle = "#f4f7ff";
ctx.fillRect(-w / 2 + 5, -h / 2 + 4, w - 10, h - 13);
ctx.fillStyle = "#aeb8df";
ctx.fillRect(-w / 2 + 3, h / 2 - 9, w - 6, 8);
ctx.fillStyle = obstacle.hp === 1 ? "#ff5c72" : "#07070f";
ctx.font = "bold 10px monospace";
ctx.textAlign = "center";
ctx.textBaseline = "middle";
ctx.fillText("KEY", 0, 0);
} else if (obstacle.type === "lag") {
ctx.fillStyle = "rgba(255, 92, 114, 0.28)";
ctx.fillRect(-w / 2 - 4, -h / 2 - 4, w + 8, h + 8);
ctx.fillStyle = "#ff5c72";
ctx.fillRect(-w / 2, -h / 2, w, h);
ctx.fillStyle = "#07070f";
ctx.fillRect(-w / 2 + 6, -h / 2 + 7, w - 12, h - 14);
ctx.fillStyle = "#f4f7ff";
ctx.font = "bold 11px monospace";
ctx.textAlign = "center";
ctx.textBaseline = "middle";
ctx.fillText("LAG", 0, 0);
ctx.strokeStyle = "#d9ff4a";
ctx.lineWidth = 2;
ctx.beginPath();
ctx.moveTo(-w * 0.36, h * 0.36);
ctx.lineTo(w * 0.36, -h * 0.36);
ctx.stroke();
} else {
ctx.fillStyle = "rgba(42, 246, 255, 0.24)";
ctx.fillRect(-w / 2 - 5, -h / 2 - 5, w + 10, h + 10);
ctx.fillStyle = "#11121f";
ctx.fillRect(-w / 2, -h / 2, w, h);
ctx.fillStyle = "#2af6ff";
ctx.fillRect(-w / 2 + 4, -h / 2 + 4, w - 8, h - 8);
ctx.fillStyle = "#07070f";
ctx.fillRect(-w / 2 + 8, -h / 2 + 8, w - 16, h - 16);
ctx.fillStyle = "#ff39d5";
ctx.fillRect(-4, -h / 2 - 12, 8, 14);
ctx.fillStyle = "#d9ff4a";
ctx.fillRect(-10, -4, 20, 8);
ctx.fillStyle = "#f4f7ff";
ctx.font = "bold 9px monospace";
ctx.textAlign = "center";
ctx.textBaseline = "middle";
ctx.fillText("SW", 0, h * 0.18);
}
ctx.restore();
}
function drawPowerUp(powerUp) {
ctx.save();
ctx.translate(Math.round(powerUp.x), Math.round(powerUp.y));
ctx.rotate(powerUp.rot);
ctx.globalAlpha = 0.28 + Math.sin(powerUp.pulse) * 0.08;
ctx.fillStyle = powerUp.color;
ctx.fillRect(-powerUp.r - 3, -powerUp.r - 3, powerUp.r * 2 + 6, powerUp.r * 2 + 6);
ctx.globalAlpha = 1;
if (powerUp.id === "opticLaser") {
ctx.fillStyle = "#2af6ff";
ctx.fillRect(-5, -18, 10, 36);
ctx.fillStyle = "#f4f7ff";
ctx.fillRect(-2, -22, 4, 44);
ctx.fillStyle = "#ff39d5";
ctx.fillRect(-15, 9, 30, 5);
} else if (powerUp.id === "rapidTrigger") {
ctx.fillStyle = "#61ff8a";
ctx.fillRect(-17, -14, 34, 28);
ctx.fillStyle = "#07070f";
ctx.fillRect(-10, -7, 20, 14);
ctx.fillStyle = "#f4f7ff";
ctx.fillRect(1, -20, 5, 10);
} else if (powerUp.id === "antiGravity") {
ctx.fillStyle = "#a987ff";
ctx.fillRect(-18, 4, 36, 10);
ctx.fillStyle = "#f4f7ff";
ctx.fillRect(-3, -19, 6, 28);
ctx.fillStyle = "#2af6ff";
ctx.fillRect(-12, -9, 24, 5);
} else if (powerUp.id === "shotgun") {
ctx.fillStyle = "#ff7d4a";
ctx.fillRect(-17, -7, 34, 14);
ctx.fillStyle = "#f4f7ff";
ctx.fillRect(-5, -18, 10, 14);
ctx.fillRect(-17, -16, 8, 10);
ctx.fillRect(9, -16, 8, 10);
} else if (powerUp.id === "fluxBomb") {
ctx.fillStyle = "#ffb038";
ctx.fillRect(-13, -16, 26, 28);
ctx.fillStyle = "#07070f";
ctx.fillRect(-7, -10, 14, 17);
ctx.fillStyle = "#d9ff4a";
ctx.fillRect(-16, 9, 32, 5);
ctx.fillStyle = "#ff39d5";
ctx.fillRect(-3, -23, 6, 7);
} else {
ctx.fillStyle = "#f4f7ff";
ctx.fillRect(-23, -9, 46, 18);
ctx.fillStyle = "#aeb8df";
ctx.fillRect(-18, -4, 36, 9);
ctx.fillStyle = "#2af6ff";
ctx.fillRect(-21, 8, 42, 4);
}
ctx.fillStyle = powerUp.id === "phaseShield" ? "#07070f" : "#f4f7ff";
ctx.font = powerUp.label.length > 3 ? "bold 7px monospace" : "bold 9px monospace";
ctx.textAlign = "center";
ctx.textBaseline = "middle";
ctx.fillText(powerUp.label, 0, powerUp.id === "phaseShield" ? 0 : 19);
ctx.restore();
}
function drawShield(player) {
if (state.effects.shield <= 0) return;
ctx.save();
ctx.translate(Math.round(player.x), Math.round(player.y));
const pulse = 0.58 + Math.sin(state.elapsed * 18) * 0.18;
const radius = 45 + Math.sin(state.elapsed * 14) * 4;
ctx.fillStyle = `rgba(244, 247, 255, ${0.08 + pulse * 0.04})`;
ctx.beginPath();
ctx.arc(0, -2, radius, 0, Math.PI * 2);
ctx.fill();
ctx.strokeStyle = `rgba(244, 247, 255, ${pulse})`;
ctx.lineWidth = 3;
ctx.beginPath();
ctx.arc(0, -2, radius, 0, Math.PI * 2);
ctx.stroke();
ctx.strokeStyle = "rgba(42, 246, 255, 0.62)";
ctx.lineWidth = 1;
ctx.beginPath();
ctx.arc(0, -2, radius + 8, state.elapsed * 3, state.elapsed * 3 + Math.PI * 1.55);
ctx.stroke();
ctx.strokeStyle = "rgba(217, 255, 74, 0.5)";
ctx.beginPath();
ctx.arc(0, -2, radius + 15, -state.elapsed * 2, -state.elapsed * 2 + Math.PI * 1.15);
ctx.stroke();
ctx.restore();
}
function drawRings() {
for (const ring of state.rings) {
const alpha = clamp(ring.life / ring.max, 0, 1);
ctx.save();
ctx.globalAlpha = alpha;
ctx.strokeStyle = ring.color;
ctx.lineWidth = 4;
ctx.beginPath();
ctx.arc(ring.x, ring.y, ring.r, 0, Math.PI * 2);
ctx.stroke();
ctx.restore();
}
}
function drawG6HEShip(player) {
const t = state.elapsed;
ctx.save();
ctx.translate(Math.round(player.x), Math.round(player.y));
const bob = Math.sin(t * 9) * 2;
ctx.translate(0, bob);
const s = 3;
ctx.scale(s, s);
pixelRect(-7, 16, 14, 3, "rgba(42, 246, 255, 0.42)");
pixelRect(-4, 19, 8, 5 + Math.floor(Math.sin(t * 18) * 2 + 2), state.effects.rapid > 0 ? "#61ff8a" : "#ffb038");
pixelRect(-2, 22, 4, 7, "#ff39d5");
pixelRect(-10, 9, 4, 6, "#2af6ff");
pixelRect(6, 9, 4, 6, "#d9ff4a");
pixelRect(-3, -18, 6, 3, "#f4f7ff");
pixelRect(-6, -15, 12, 3, "#e9efff");
pixelRect(-8, -12, 16, 4, "#dbe4ff");
pixelRect(-9, -8, 18, 6, "#cfd8f5");
pixelRect(-8, -2, 16, 6, "#e7edff");
pixelRect(-7, 4, 14, 7, "#d7e1ff");
pixelRect(-5, 11, 10, 5, "#aeb8df");
pixelRect(-7, -12, 6, 12, "#f6f8ff");
pixelRect(1, -12, 6, 12, "#f0c9ff");
pixelRect(-1, -15, 2, 18, "#07070f");
pixelRect(-2, -10, 4, 4, "#d9ff4a");
pixelRect(-10, -4, 2, 12, "#ff39d5");
pixelRect(8, -4, 2, 12, "#2af6ff");
pixelRect(-7, 8, 3, 3, "#ff39d5");
pixelRect(4, 8, 3, 3, "#2af6ff");
ctx.fillStyle = "#07070f";
ctx.font = "4px monospace";
ctx.textAlign = "center";
ctx.fillText("G6", 0, 8);
ctx.font = "3px monospace";
ctx.fillStyle = "#d9ff4a";
ctx.fillText("HE", 0, 13);
ctx.fillStyle = "#2af6ff";
ctx.font = "3px monospace";
ctx.fillText("OPT", -12, -15);
ctx.fillStyle = "#ff39d5";
ctx.fillText("HE", 12, -15);
ctx.restore();
}
function drawCat(cat) {
ctx.save();
ctx.translate(Math.round(cat.x), Math.round(cat.y));
ctx.rotate(cat.rot);
const glow = 0.4 + Math.sin(state.elapsed * 5 + cat.phase) * 0.12;
if (cat.repelGlow > 0) {
ctx.strokeStyle = `rgba(244, 247, 255, ${0.4 + cat.repelGlow})`;
ctx.lineWidth = 4;
ctx.strokeRect(-cat.size * 0.82, -cat.size * 0.82, cat.size * 1.64, cat.size * 1.64);
}
ctx.fillStyle = `rgba(255, 57, 213, ${glow})`;
ctx.fillRect(-cat.size * 0.7, -cat.size * 0.45, cat.size * 1.1, cat.size * 0.9);
ctx.fillStyle = "rgba(42, 246, 255, 0.22)";
ctx.fillRect(-cat.size * 0.45, -cat.size * 0.65, cat.size * 1.05, cat.size * 1.15);
const s = cat.size / 16;
ctx.scale(s, s);
pixelRect(-7, -3, 14, 10, "#f0b7e7");
pixelRect(-5, -7, 3, 4, "#f0b7e7");
pixelRect(2, -7, 3, 4, "#f0b7e7");
pixelRect(-4, -6, 2, 2, "#ff39d5");
pixelRect(2, -6, 2, 2, "#ff39d5");
pixelRect(-8, 0, 1, 5, "#c98bc2");
pixelRect(7, 0, 1, 5, "#c98bc2");
pixelRect(-4, 0, 2, 2, "#07070f");
pixelRect(2, 0, 2, 2, "#07070f");
pixelRect(-1, 2, 2, 1, "#ff5c72");
pixelRect(-5, 4, 10, 1, "#c98bc2");
pixelRect(-10, 2, 4, 1, "#d9ff4a");
pixelRect(6, 2, 4, 1, "#d9ff4a");
pixelRect(-10, 5, 4, 1, "#d9ff4a");
pixelRect(6, 5, 4, 1, "#d9ff4a");
ctx.restore();
}
function drawParticles() {
for (const particle of state.particles) {
const alpha = clamp(particle.life / particle.max, 0, 1);
ctx.globalAlpha = alpha;
ctx.fillStyle = particle.color;
ctx.fillRect(Math.round(particle.x), Math.round(particle.y), particle.size, particle.size);
}
ctx.globalAlpha = 1;
}
function drawEffectWash() {
ctx.save();
if (state.effects.gravity > 0) {
ctx.globalAlpha = 0.12;
ctx.fillStyle = "#a987ff";
for (let i = 0; i < 9; i += 1) {
const y = (H - ((state.elapsed * 90 + i * 96) % (H + 80)));
ctx.fillRect(32 + i * 48, y, 3, 54);
}
}
if (state.effects.latency > 0) {
ctx.globalAlpha = 0.16;
ctx.fillStyle = "#ff5c72";
for (let i = 0; i < 12; i += 1) {
const y = (state.elapsed * 90 + i * 59) % H;
ctx.fillRect(0, y, W, 2);
}
}
ctx.restore();
}
function drawShieldTimer() {
if (!shieldActive()) return;
const seconds = Math.max(0, state.effects.shield).toFixed(1);
ctx.save();
ctx.fillStyle = "rgba(7, 7, 15, 0.84)";
ctx.fillRect(14, 14, 128, 34);
ctx.strokeStyle = "rgba(244, 247, 255, 0.82)";
ctx.lineWidth = 1;
ctx.strokeRect(14, 14, 128, 34);
ctx.fillStyle = "#d9ff4a";
ctx.font = "bold 13px monospace";
ctx.textAlign = "left";
ctx.textBaseline = "middle";
ctx.fillText(`SHD INV ${seconds}s`, 24, 31);
ctx.restore();
}
function draw() {
ctx.imageSmoothingEnabled = false;
ctx.save();
const shakeX = state.shake ? (Math.random() - 0.5) * state.shake * 10 : 0;
const shakeY = state.shake ? (Math.random() - 0.5) * state.shake * 10 : 0;
ctx.translate(shakeX, shakeY);
const gradient = ctx.createLinearGradient(0, 0, 0, H);
gradient.addColorStop(0, "#07070f");
gradient.addColorStop(0.55, "#0b1024");
gradient.addColorStop(1, "#13081d");
ctx.fillStyle = gradient;
ctx.fillRect(-20, -20, W + 40, H + 40);
drawStars();
drawGrid();
drawEffectWash();
ctx.save();
ctx.globalAlpha = 0.2;
ctx.fillStyle = "#ff39d5";
ctx.fillRect(28, 90 + Math.sin(state.elapsed) * 8, 62, 6);
ctx.fillStyle = "#2af6ff";
ctx.fillRect(W - 120, 160 + Math.cos(state.elapsed * 0.7) * 10, 84, 5);
ctx.fillStyle = "#d9ff4a";
ctx.fillRect(70 + Math.sin(state.elapsed * 1.2) * 18, H - 160, 72, 4);
ctx.restore();
drawRings();
for (const bullet of state.bullets) drawBullet(bullet);
for (const obstacle of state.obstacles) drawObstacle(obstacle);
for (const cat of state.cats) drawCat(cat);
for (const powerUp of state.powerUps) drawPowerUp(powerUp);
drawG6HEShip(state.player);
drawShield(state.player);
drawParticles();
drawShieldTimer();
ctx.restore();
}
function loop(now) {
const dt = state.last ? Math.min(0.034, (now - state.last) / 1000) : 0;
state.last = now;
if (state.running && !state.paused && !state.gameOver) {
update(dt);
}
draw();
state.raf = requestAnimationFrame(loop);
}
function startLoop() {
if (state.raf) return;
state.last = 0;
state.raf = requestAnimationFrame(loop);
}
startButton.addEventListener("click", startOrResume);
restartButton.addEventListener("click", () => {
unlockAudio();
resetGame();
});
pauseButton.addEventListener("click", togglePause);
audioButton.addEventListener("click", () => {
audio.enabled = !audio.enabled;
audioButton.textContent = audio.enabled ? "Sound On" : "Sound Off";
if (audio.enabled) unlockAudio();
});
document.addEventListener("keydown", (event) => {
unlockAudio();
if (event.code === "Escape") return;
if (event.code === "KeyP") {
event.preventDefault();
togglePause();
return;
}
if (event.code === "KeyR") {
event.preventDefault();
if (state.running || state.gameOver) resetGame();
return;
}
const key = KEY[event.code];
if (key) {
event.preventDefault();
if (!state.running || state.gameOver) return;
state.input[key] = true;
}
});
document.addEventListener("keyup", (event) => {
const key = KEY[event.code];
if (key) {
event.preventDefault();
state.input[key] = false;
}
});
canvas.addEventListener("pointerdown", (event) => {
unlockAudio();
if (!state.running || state.gameOver) return;
if (state.paused) startOrResume();
canvas.setPointerCapture(event.pointerId);
const pos = getPointerPosition(event);
state.pointerActive = true;
state.player.targetX = pos.x;
state.player.targetY = pos.y;
});
canvas.addEventListener("pointermove", (event) => {
if (!state.pointerActive) return;
const pos = getPointerPosition(event);
state.player.targetX = pos.x;
state.player.targetY = pos.y;
});
canvas.addEventListener("pointerup", () => {
state.pointerActive = false;
});
canvas.addEventListener("pointercancel", () => {
state.pointerActive = false;
});
firePad.addEventListener("pointerdown", (event) => {
event.preventDefault();
unlockAudio();
if (!state.running || state.gameOver) return;
if (state.paused) startOrResume();
state.input.fire = true;
firePad.setPointerCapture(event.pointerId);
});
firePad.addEventListener("pointerup", () => {
state.input.fire = false;
});
firePad.addEventListener("pointercancel", () => {
state.input.fire = false;
});
syncHud();
prepareGame();
setOverlay("ready");
startLoop();
draw();
})();
